import * as React from "react";
import { Admin, Resource } from "react-admin";
import { authProvider } from "./utils/authProvider";
import { AzureAD } from "react-aad-msal";
import {
  TemplatesList,
  TemplateCreate,
  TemplateEdit,
  TemplateShow,
} from "./components/lists/TemplatesList";
import { AdminPortal } from "./components/AdminPortal";
import { customizedDataProvider } from "./utils/dataProvider";
import SessionsList from "./components/lists/SessionsList";
import UsersList, {
  UserCreate,
  UserEdit,
  UserShow,
} from "./components/lists/UsersList";
import { eosTheme } from "./style/theme";
import PeopleIcon from "@material-ui/icons/People";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import {
  CustomerCreate,
  CustomerEdit,
  CustomerShow,
  CustomersList,
} from "./components/lists/CustomersList";
import {
  ResourcesList,
  ResourceCreate,
  ResourceShow,
  ResourceEdit,
} from "./components/lists/ResourcesList";
import BusinessIcon from "@material-ui/icons/Business";
import HelpCenterIcon from "@material-ui/icons/Help";

const App = () => (
  <AzureAD provider={authProvider} forceLogin={true}>
    <AdminPortal>
      <Admin dataProvider={customizedDataProvider} theme={eosTheme} >
        <Resource
          name="templates"
          list={TemplatesList}
          icon={LibraryBooksIcon}
          edit={TemplateEdit}
          create={TemplateCreate}
          show={TemplateShow}
        />
        <Resource
          name="vm/admin"
          options={{ label: "VM Sessions" }}
          list={SessionsList}
          icon={PlayCircleOutlineIcon}
        />
        <Resource
          name="users"
          list={UsersList}
          icon={PeopleIcon}
          create={UserCreate}
          edit={UserEdit}
          show={UserShow}
        />
        <Resource
          name="customers"
          list={CustomersList}
          icon={BusinessIcon}
          edit={CustomerEdit}
          create={CustomerCreate}
          show={CustomerShow}
        />
        <Resource
          name="resources"
          options={{ label: "Resources" }}
          list={ResourcesList}
          icon={HelpCenterIcon}
          create={ResourceCreate}
          edit={ResourceEdit}
          show={ResourceShow}
        />
      </Admin>
    </AdminPortal>
  </AzureAD>
);

export default App;
